module.exports = __webpack_public_path__ + "img/app-preloader.dc55c099.svg";